import React from 'react';

function CourseItem(props) {
  const { title } = props
  return (
    <>

      <div class="card card-cascade wider h-100" style={{ background: "#ECFFFB", boxShadow: "0 15px 10px #f5d7d752" }} >
        <div className='position-relative '>

          <img class="card-img-top" src="https://mdbootstrap.com/img/Photos/Others/photo6.webp" style={{ borderRadius: "0% 24% 26% 79% / 0% 34% 58% 100% " }} alt="Card image cap" />

          <span class="badge badge-pill badge-info position-absolute px-2" style={{ bottom: "0", left: "5px" }}>JavaScript</span>
        </div>

        <div class="card-body card-body-cascade d-flex flex-column justify-content-evenly pb-0">

          <h5 className='black-text text-terminate text-terminate-2'>*{title}* Lorem ipsum dolor sit amet consectetur, adipisicing elit. Atque, ut, id, consectetur quam dicta tempora nostrum molestias veritatis ex sed magni autem nemo tempore doloremque quod voluptatem? Dolore, optio eius?</h5>
          <p className='text-black-50 text-terminate text-terminate-4'>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam voluptates, assumenda totam ad neque optio dignissimos sapiente deleniti dolor aliquam unde ipsum omnis ipsa ipsam illum quia repellendus rerum porro.</p>
          <div className="review mb-2">
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star-outline" style={{ color: "#777777", fontSize: "18px" }}></ion-icon>
            <ion-icon name="star-outline" style={{ color: "#777777", fontSize: "18px" }}></ion-icon>
            <span className='text-muted' style={{ fontSize: "13px" }}> (Based on 4 review) </span>
          </div>
          <div className="profile d-flex justify-content-around my-1">
            <div className="d-flex align-items-center">
              <img src={require("../resource/avater.png")} style={{ borderRadius: "21% 69% 54% 45% / 59% 68% 29% 48%  ", background: "orange", width: "50px", height: "50px", overflow: "hidden" }} alt="ss" />
              <h6 className='text-black-50 mx-3'>Sahil saif</h6>
            </div>
            <a href="" className="btn white-text teal accent-4">4000</a>
          </div>

        </div>

      </div>
    </>
  )
}

export default CourseItem;
